module.exports = __webpack_public_path__ + "static/img/img_app.c1eb30c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partners_pc/img_app.gif
// module id = wXZK
// module chunks = 1